import React, { useRef } from "react"

import useTracking from "hooks/useTracking"
import useUserAgent from "hooks/useUserAgent"

import Seo from "components/seo"
import ContentfulNavigation from "components/page-components/navigation"
import MoreArticles from "../category/more-articles"
import { Wrapper, Container } from "./styles"

const Tag = ({ tag, articles }) => {
  const { track, trackRender } = useTracking()
  const ref = useRef(null)
  trackRender(ref, null, {}, (props) => track("Tag Page Viewed", props))

  const isSearchBot = useUserAgent()

  return (
    <>
      <Seo
        title={`${tag.tag} on mindbodygreen`}
        description={`The best content about ${tag.tag} on mindbodygreen`}
        canonical={`${process.env.GATSBY_LOCAL_SITE}/tag/${tag.slug}`}
        robots="noindex"
      />
      <Wrapper ref={ref}>
        <ContentfulNavigation />
        <Container id="content">
          <MoreArticles
            title={tag.tag}
            articles={articles}
            loadImmediately={isSearchBot}
            pageType="Tag"
          />
        </Container>
      </Wrapper>
    </>
  )
}

export default Tag
